import React from 'react';
import ServiceInterviewNoticeView from './view';
import Provider from 'stores/ServiceStatusStore';

function ServiceInterviewNotice(): React.ReactElement {
    return (
        <Provider>
            <ServiceInterviewNoticeView />
        </Provider>
    );
}

export default ServiceInterviewNotice;
